import { Intents, type IntentName, type IntentPayload } from "@spacecrew/shared";
import { getRoom } from "./session.svelte.js";

/** Parse with the shared zod schema before sending — the server validates again; never trust the client. */
declare global { interface Window { __send?: typeof send } }
if (new URLSearchParams(location.search).has("debug")) window.__send = (n, p) => send(n, p);

export function send<K extends IntentName>(name: K, payload: IntentPayload<K>): void {
  const room = getRoom();
  if (!room) return;
  const parsed = Intents[name].safeParse(payload);
  if (!parsed.success) { console.warn("[intent] invalid payload", name, parsed.error); return; }
  room.send(name, parsed.data);
}
